import React, { useState, useEffect } from "react";

import Loader from "../Components/Loader";
import TTSSetting from "../DataDisplay/TTSSetting";
import { getTTSSettings, formatTTS, editTTSSettings, getGroups } from "../Requests/TTSAdminRequests";

import "../Styles/TTS_Settings.css";

const removeDuplicates = (list) => {
    const keys = {};
    const copy = [];

    list.forEach(item => {
        if(!keys[item.code]){
            copy.push(item);
            keys[item.code] = true;
        }
    });

    return copy;
}

const TTS_Admin_Page = (props) => {

    const [settings, setSettings] = useState([]);
    const [type, setType] = useState(props.is_multistation ? "rail" : "bus");

    const [filter, setFilter] = useState("");
    const [filteredSettings, setFilteredSettings] = useState([]);

    const [loading, setLoading] = useState(false);

    const [groups, setGroups] = useState([]);
    const [activeIndex, setActiveIndex] = useState(null);

    useEffect(() => {
        // load the current settings
        getData();
    }, []);

    useEffect(() => {
        // load the current settings
        console.log("TYPE CHANGED");
        setSettings([]);
        getData();
    }, [type]);

    useEffect(() => {
        if(filter === ""){
            setFilteredSettings(settings);
            return;
        }
        
        const flower = filter.toLowerCase();
        const f = settings.filter(v => {
            return (v.location.toLowerCase().indexOf(flower) > -1);
        });
        setFilteredSettings(f);
    }, [filter, settings]);

    const getData = () => {
        setLoading(true);

        //
        // always get the groups first
        //
        getGroups(type)
        .then(({data}) => {
            console.log("THE SERVER AND GROUP DATA", data);
            
            const g = [];
            const AWS = {name: "AWS", groups: []};
            const OnPrem = {name: "Newark_HQ", groups: []};

            data.forEach(d => {
                if(d.TTS_HOST === "AWS"){
                    // if(type === "rail"
                    //     || (type !== "rail" && (d.SERVER_GROUP.toLowerCase().includes(type.toLowerCase)))
                    // ){
                    // }
                    AWS.groups.push({name: d.SERVER_GROUP});
                }
                else{                
                    OnPrem.groups.push({name: d.SERVER_GROUP});
                }
            });

            g.push(AWS);
            g.push(OnPrem);

            console.log("COLLECTED GROUPS", g);
            setGroups(g);

            getTTSSettings(type)
            .then(({data}) => {
                console.log("CURRENT SETTINGS", data);

                const dataToUse = removeDuplicates(data);

                setSettings(dataToUse);
                setLoading(false);
            });
        });
    }

    const getGroupListing = () => {
        getGroups(type)
        .then(({data}) => {
            console.log("THE SERVER AND GROUP DATA", data);
            
            const g = [];
            const AWS = {name: "AWS", groups: []};
            const OnPrem = {name: "Newark_HQ", groups: []};

            data.forEach(d => {
                if(d.TTS_HOST === "AWS"){
                    AWS.groups.push({name: d.SERVER_GROUP});
                }
                else{                
                    OnPrem.groups.push({name: d.SERVER_GROUP});
                }
            });

            g.push(AWS);
            g.push(OnPrem);

            console.log("COLLECTED GROUPS", g);
            setGroups(g);
        });
    }

    const toggleSetting = (index) => {
        console.log("TOGGLE SETTING PARENT");
        const copy = [...filteredSettings];

        const s = copy[index];
        if(s.value === "AWS"){
            s.value = "NEWARK_HQ";
        }
        else{
            s.value = "AWS";
        }

        const params = {
            location: s.location,
            code: s.code,
            ttsurl: s.value
        };

        console.log("TTS EDIT PARAMS", params, s);

        editTTSSettings(type, params)
        .then(({data}) => {
            // if successful?
            getData(type);
        });
    }

    const changeGroupSetting = (index, server, group) => {

        console.log("CHANGE GROUP SETTING", index, server, group);

        const copy = [...filteredSettings];

        const s = copy[index];
        s.value = server;

        console.log("EDIT VALUE", s);

        const params = {
            location: s.location,
            code: s.code,
            ttsurl: s.value,
            group
        };

        console.log("TTS EDIT PARAMS", params, s);

        editTTSSettings(type, params)
        .then(({data}) => {
            // if successful?
            getData(type);
            setActiveIndex(null);
        });
    }

    const closeActive = () => {
        setActiveIndex(null);
    }

    return (
        <div className="tts-content">
            {
                !props.is_multistation
                ? <div className="tts-nav-buttons">
                    <button className={(type === "bus") ? "active" : ""} onClick={() => setType("bus")}>BUS</button>
                    <button className={(type === "rail") ? "active" : ""} onClick={() => setType("rail")}>RAIL</button>
                    <button className={(type === "lightrail") ? "active" : ""} onClick={() => setType("lightrail")}>NLR</button>
                    <button className={(type === "riverline") ? "active" : ""} onClick={() => setType("riverline")}>Riverline</button>
                    <div className="filter-div">
                        <input type="text" placeholder="FILTER BY LOCATION" value={filter} onChange={evt => setFilter(evt.target.value)} />
                    </div>
                </div>
                : <div className="tts-nav-buttons">
                    <div className="filter-div">
                        <input type="text" placeholder="FILTER BY LOCATION" value={filter} onChange={evt => setFilter(evt.target.value)} />
                    </div>
                </div>
            }
            <div className="tts-container">
                {
                    filteredSettings.map((s, index) => {
                        console.log("DATA ELEMENT", s);
                        return (
                            <TTSSetting 
                                key={s.location + "_" + index} 
                                index={index} 
                                location={s.location} 
                                server={s}
                                value={s.value} 
                                group={s.group} 
                                groups={groups} 
                                toggle={() => toggleSetting(index)} 
                                activeIndex={activeIndex} 
                                changeGroup={changeGroupSetting} 
                                closeActive={closeActive}
                                type={type} 
                            />
                        )
                    })
                }
            </div>
            {
                loading
                ? <Loader />
                : null
            }
        </div>
    )
}

export default TTS_Admin_Page;